module.exports = __webpack_public_path__ + "img/bank7.534dc1b1.png";